import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../constants/svgIcon';
import { getWebBoosterVairant } from '../../../constants/webBoosterType';
import { WebBoosterType } from '../../../models/UserStore';
import { SvgIcon } from '../SVGIcon';

import styles from './AIExamMemoryBoosterBanner.module.css';

interface AIExamMemoryBoosterBannerProps {
  webBoosterType: WebBoosterType | undefined;
  onClickBoostVideo: () => void;
  onClickSwitchBooster: () => void;
}

export const AIExamMemoryBoosterBanner = ({
  webBoosterType,
  onClickBoostVideo,
  onClickSwitchBooster,
}: AIExamMemoryBoosterBannerProps) => {
  const { t } = useTranslation();
  return (
    <div
      className={styles.banner}
      style={{
        backgroundImage: `url(${
          getWebBoosterVairant(webBoosterType).backgroundImage
        })`,
      }}
    >
      <div className={styles.playerContainer} onClick={onClickBoostVideo}>
        <SvgIcon
          className={styles.playerIcon}
          name={SVGIconType.PlayerPlay}
          color={'white'}
        />
      </div>
      <div className={styles.hContainer} onClick={onClickSwitchBooster}>
        <SvgIcon
          name={getWebBoosterVairant(webBoosterType).icon}
          className={styles.scoreAIcon}
        />

        <p
          className={`${styles.bannerText} ${
            styles[getWebBoosterVairant(webBoosterType).classVariant]
          }`}
        >
          {t(getWebBoosterVairant(webBoosterType).name)}
        </p>
      </div>
      <div className={styles.arrowContainer} onClick={onClickSwitchBooster}>
        <SvgIcon
          className={styles.arrowContainer}
          name={SVGIconType.Triangle}
          color={'#217079'}
        />
      </div>
    </div>
  );
};
